(function($) {
    $(document).on('click', '.js-target-tab',function(e) {
        e.preventDefault();
        const target = $(this).data('target');
        $('.webinar-tabs__tab').removeClass('webinar-tabs__tab--active');
        $(this).parent().addClass('webinar-tabs__tab--active');
        $('.js-tab-area').addClass('hidden');
        $(target).removeClass('hidden');
    });
})(jQuery);